import "./CategoriesPage.scss";
import { useEffect } from "preact/hooks";

const CategoriesPage = () => {
  useEffect(() => {
    document.title = "All Coupon Categories — EZ Coupons Utah County";
  }, []);

  const categories = [
    { title: "Restaurants", id: "120000", icon: "fa fa-utensils", subcategories: [
      { title: "Mexican", id: "120302" }, { title: "Italian", id: "120401" }, { title: "American", id: "120200" }
    ]},
    { title: "Entertainment", id: "070000", icon: "fa fa-film", subcategories: [
      { title: "Movies", id: "070300" }, { title: "Music", id: "070100" }, { title: "Dance", id: "070400" }
    ]},
    { title: "Clothing & Jewelry", id: "040000", icon: "fa fa-tshirt", subcategories: [
      { title: "Jewelry", id: "040200" }, { title: "Women's Clothing", id: "040115" }, { title: "Shoes", id: "040112" }
    ]},
    { title: "Sports & Hobbies", id: "130000", icon: "fa fa-futbol", subcategories: [
      { title: "Hobbies", id: "130200" }, { title: "Sports", id: "130300" }, { title: "Exercise", id: "130600" }
    ]},
    { title: "Home & Family", id: "090000", icon: "fa fa-home", subcategories: [
      { title: "Flowers", id: "090906" }, { title: "Yard Care", id: "090800" }, { title: "Furniture", id: "090600" }
    ]},
    { title: "Health & Beauty", id: "080000", icon: "fa fa-plus", subcategories: [
      { title: "Beauty", id: "080100" }, { title: "Health", id: "080200" }
    ]},
    { title: "Personal Services & Bridal", id: "110000", icon: "fa fa-heart", subcategories: [
      { title: "Dry Cleaning", id: "110203" }, { title: "Laundry", id: "110206" }, { title: "Bridal", id: "110300" }
    ]},
    { title: "Medical & Dental", id: "100000", icon: "fa fa-medkit", subcategories: [
      { title: "Eyecare", id: "100200" }, { title: "Dental", id: "100100" }, { title: "Services", id: "100400" }
    ]},
    { title: "Travel & Lodging", id: "140000", icon: "fa fa-plane", subcategories: [
      { title: "Lodging", id: "140200" }, { title: "Transportation", id: "140400" }, { title: "Travel", id: "140100" }
    ]},
    { title: "Auto", id: "020000", icon: "fa fa-car", subcategories: [
      { title: "New", id: "020202" }, { title: "Used", id: "020204" }, { title: "Service", id: "020300" }
    ]},
    { title: "Appliances & Electronics", id: "010000", icon: "fa fa-plug", subcategories: [
      { title: "Electronics", id: "010100" }, { title: "Appliances", id: "010200" }
    ]},
    { title: "Computer & Internet", id: "050000", icon: "fa fa-wifi", subcategories: [
      { title: "New", id: "050101" }, { title: "Used", id: "050102" }, { title: "Internet", id: "050200" }, { title: "Software", id: "050109" }
    ]},
    { title: "Business, Financial & Legal", id: "030000", icon: "fa fa-balance-scale", subcategories: [
      { title: "Advertising", id: "030200" }, { title: "Attorneys", id: "030400" }, { title: "Banks", id: "030300" }
    ]},
    { title: "Construction & Real Estate", id: "060000", icon: "fa fa-building", subcategories: [
      { title: "Contractors", id: "060300" }, { title: "Suppliers", id: "060400" }
    ]},
  ];

  return (
    <div className={"categories-container"}>
      {categories.map((category, index) => [
        index % 4 === 0 && <div className={"break"} />,
        <div className={"category cat-" + Math.floor(index / 4)}>
          <a className={"category-main"} href={`/category/${category.id}`} aria-label={`${category.title} coupons`}>
            <i className={category.icon}></i>
            <h2>{category.title}</h2>
          </a>
          <div className={"subcategories"}>
            {category.subcategories.map((subcategory, i) => (
              <a
                className={"subcategory"}
                href={`/category/${subcategory.id}`}
                aria-label={`${subcategory.title} coupons`}
              >
                {subcategory.title}{i < category.subcategories.length - 1 ? ", " : ""}
              </a>
            ))}
          </div>
        </div>,
      ])}
    </div>
  );
};

export default CategoriesPage;
